import { faDiagramProject } from '@fortawesome/pro-solid-svg-icons/faDiagramProject';
import { faPencil } from '@fortawesome/pro-solid-svg-icons/faPencil';
import { faTrash } from '@fortawesome/pro-solid-svg-icons/faTrash';
import {
	Button,
	ColourStateSolid,
	FlexAlign,
	FlexJustify,
	ItemRow,
	ItemRowHeader,
	StackHorizontal,
	ToggleSwitch,
	ToggleType,
	useComboBoxSimple,
	useLayout,
} from '@ukpostbox/frontend-framework';
import React, { useRef, useState } from 'react';
import { useNavigate } from 'react-router';
import SelectEverythingBanner from '../../../_Global/Components/SelectEverythingBanner';
import SelectionBar from '../../../_Global/Components/SelectionBar';

const data = [
	{
		active: false,
		id: 346436,
		name: 'Some Ruleset',
	},
	{
		active: true,
		id: 5476678,
		name: 'Catalogue Destruction',
	},
];

const DummyData = [
	{
		active: false,
		name: 'Some Ruleset ',
		scanType: 1,
		applyToExisting: false,
		action: { id: 0, values: [27859, 27858, 27799] },
		filters: [
			{
				id: 2,
				values: [62122, 62144, 62231],
				includes: false,
			},
		],
	},
	{
		active: true,
		name: 'Catalogue Destruction',
		applyToExisting: true,
		scanType: 1,
		action: { id: 5, values: 4 },
		filters: [
			{ id: 2, includes: true, values: [62122, 62144, 62231] },
			{ id: 3, values: 0 },
			{ id: 0, includes: true, sender: undefined },
		],
	},
];

function Rulesets() {
	const navigate = useNavigate();
	const { isXL } = useLayout();

	const rulesContainerRef = useRef<any>(null);

	const [itemCounts, setItemCounts] = useState<any>({ loaded: 0, total: 0 });

	const {
		allSelected,
		visibleSelected,
		visibleIndeterminate,
		selectedItems,
		ToggleAll,
		ToggleVisible,
		ToggleSelected,
		ResetSelection,
	} = useComboBoxSimple();

	return (
		<>
			<StackHorizontal align={FlexAlign.Center} justify={FlexJustify.Between} extraClass='mb-xs'>
				<h2 className='mb-0'>Rulesets</h2>
				<Button
					title='New Ruleset'
					squared
					colour={ColourStateSolid.Primary}
					icon={faDiagramProject}
					onClick={() => navigate('/manage-account/rulesets/add')}
				/>
			</StackHorizontal>

			<div className='card rule-sets-rows' ref={rulesContainerRef}>
				<ItemRowHeader title='Rulesets' sticky>
					<div className='item-row-checkbox'>
						<ToggleSwitch
							name='tagsAll'
							label='tags-all'
							invalid={false}
							type={ToggleType.Checkbox}
							defaultChecked={allSelected || (!visibleIndeterminate && visibleSelected)}
							isIndeterminate={!allSelected && visibleIndeterminate}
							onChange={(e: any) => ToggleVisible(data, 'id', !visibleSelected)}
							hideLabel
						/>
					</div>

					{selectedItems.length === 0 && (
						<>
							<div className='sm-sub-heading'>Name</div>
							<div className='sm-sub-heading' />
							<div className='sm-sub-heading'>Active</div>
						</>
					)}

					{selectedItems.length > 0 && (
						<SelectionBar selectedIds={selectedItems} clearSelectionCallback={() => ResetSelection()}>
							<Button
								title='Delete'
								icon={faTrash}
								iconOnly={!isXL}
								colour={ColourStateSolid.Alert}
								squared
							/>
						</SelectionBar>
					)}
				</ItemRowHeader>

				{itemCounts.loaded !== itemCounts.total &&
					selectedItems.length !== itemCounts.total &&
					visibleSelected && (
						<SelectEverythingBanner
							selectedCount={allSelected ? itemCounts.total : selectedItems.length}
							selectedLabel={allSelected ? 'Select loaded only' : `Select all Tags`}
							callback={() => ToggleAll(!allSelected)}
						/>
					)}

				{data.map((item: any, index: number) => (
					<ItemRow title={`Rulesets Entry ${item.id}`} key={`ruleSet${item.id}`} static>
						<div className='item-row-checkbox'>
							<ToggleSwitch
								name={`tagItem-${index}`}
								label={`tagItem-${index}`}
								invalid={false}
								type={ToggleType.Checkbox}
								defaultChecked={allSelected || selectedItems.includes(item.id)}
								onChange={(e: any) => ToggleSelected(item.id, e.currentTarget.checked)}
								hideLabel
							/>
						</div>
						<div>{item.name}</div>
						<div className='flex-row flex-gap-xs'>
							<Button
								title='Edit'
								onClick={() => navigate('/manage-account/rulesets/add', { state: DummyData[index] })}
								colour={ColourStateSolid.Secondary}
								squared
								iconOnly
								icon={faPencil}
							/>
						</div>
						<div>
							<ToggleSwitch
								name='toggleItem'
								label='Enabled?'
								defaultChecked={item.active}
								type={ToggleType.Switch}
								hideLabel
							/>
						</div>
					</ItemRow>
				))}
			</div>
		</>
	);
}

export default Rulesets;
